export default __webpack_public_path__ + "static/media/press_room_thumb15.726e4d56.png";